import styled from 'styled-components';

const EtapaFonteAusente = ({ etapaAtual, etapasFontes, setActiveTab }) => {
  const faltantes = etapasFontes.filter(e => !e.presente);
  if (faltantes.length === 0) return null;

  const umaSo = faltantes.length === 1;

  return (
    <Container>
      <Card>
        <Titulo>Não é possível abrir {etapaAtual} ainda</Titulo>
        <Mensagem>
          {umaSo
            ? 'Esta etapa depende de dados de outra avaliação que ainda não foi preenchida. Complete a etapa abaixo antes de seguir.'
            : 'Esta etapa depende de dados de outras avaliações que ainda não foram preenchidas. Complete as etapas abaixo antes de seguir.'}
        </Mensagem>
        <ListaCTA>
          {faltantes.map(e => (
            <BotaoCTA key={e.tabKey} onClick={() => setActiveTab(e.tabKey)}>
              Ir para {e.nome}
            </BotaoCTA>
          ))}
        </ListaCTA>
      </Card>
    </Container>
  );
};

export default EtapaFonteAusente;

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px 16px;
  min-height: 300px;
  background-color: #353638;
  flex: 1;
  font-family: Poppins-Regular;
`;

const Card = styled.div`
  background: var(--color-bg-menu);
  border: 1px solid #e2e8f0;
  border-left: 4px solid var(--color-main);
  border-radius: 8px;
  padding: 32px 40px;
  max-width: 520px;
  width: 100%;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
  margin-top: -20vh
`;

const Titulo = styled.h2`
  margin: 0 0 12px 0;
  font-size: clamp(0.9rem, 1vw, 2rem);
  font-weight: 600;
  color: #fff;
`;

const Mensagem = styled.p`
  margin: 0 0 24px 0;
  font-size: clamp(0.8rem, 0.9vw, 1.8rem);
  color: #fff;
  line-height: 1.5;
`;

const ListaCTA = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const BotaoCTA = styled.button`
  background: var(--color-main);
  font-family: Poppins-Regular;
  color: #ffffff;
  border: none;
  border-radius: 6px;
  padding: 10px 16px;
  font-size: 0.95rem;
  font-weight: 500;
  cursor: pointer;
  transition: transform 0.3s ease;

  &:hover {
    transform: scale(0.95)
  }

  &:active {
    background: #1e40af;
  }
`;
